var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import localForage from 'localforage';
import nemWrapper from './nemWrapper';
import axios from 'axios';
import helper from './helper';
var getAddress = /** @class */ (function () {
    function getAddress() {
        var _this = this;
        this.address = '';
        this.mosaic_balance = 0;
        this.publicKey = '';
        this.privateKey = '';
        /*ページ切り替え */
        this.signup_modal = false;
        this.login_page = true;
        this.waitting_page = false;
        this.top_page = false;
        this.nem = new nemWrapper();
        this.helper = new helper();
        // クラス生成時にローカルストレージからアカウント情報を取得
        this.load()
            .then(function (result) {
            console.log(result);
            // 無ければアカウントを作成します
            if (result === null) {
                _this.signup_modal = true;
                _this.nem.createAccount()
                    .then(function (wallet) {
                    _this.address = wallet.address;
                    _this.privateKey = wallet.privateKey;
                    _this.helper.save('SmartUQ-Wallet', _this.toAESJSON());
                }).catch(function (error) {
                    console.error(error);
                });
            }
            console.log(_this.address);
        }).catch(function (error) {
            console.error(error);
        })
            .then(function () {
            _this.checkAccount(_this.address);
        });
    }
    //アカウントが登録されているかのflagを切り替える
    getAddress.prototype.checkAccount = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var flag;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkAccountFromAPI(address)];
                    case 1:
                        flag = _a.sent();
                        this.login_page = false;
                        if (flag == 0) { //アドレスが存在しない
                            this.login_page = true;
                        }
                        else if (flag == 10) { //承認待ち
                            this.waitting_page = true;
                        }
                        else if (flag == 11) {
                            this.top_page = true;
                        }
                        else {
                            this.login_page = true;
                        }
                        console.log("flag:" + flag);
                        return [2 /*return*/];
                }
            });
        });
    };
    //APIでアカウントが登録されているか確認
    getAddress.prototype.checkAccountFromAPI = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.address != "")) return [3 /*break*/, 2];
                        url = this.helper.path + "users/user_exist/" + this.address;
                        return [4 /*yield*/, axios.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.data];
                    case 2: return [2 /*return*/, 0];
                }
            });
        });
    };
    // ローカルストレージから取得.
    getAddress.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var key, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = 'SmartUQ-Wallet';
                        return [4 /*yield*/, localForage.getItem(key)];
                    case 1:
                        result = _a.sent();
                        if (result !== null) {
                            this.address = result.address;
                            this.privateKey = this.helper.Decrypt(result.privateKey);
                            this.publicKey = result.publicKey;
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // ローカルストレージから削除.
    getAddress.prototype.remove = function () {
        return __awaiter(this, void 0, void 0, function () {
            var key, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = 'SmartUQ-Wallet';
                        return [4 /*yield*/, localForage.removeItem(key)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    getAddress.prototype.toAESJSON = function () {
        return __awaiter(this, void 0, void 0, function () {
            var AESprivateKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.helper.Encrypt(this.privateKey)];
                    case 1:
                        AESprivateKey = _a.sent();
                        console.log("暗号化＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝");
                        console.log(AESprivateKey);
                        return [2 /*return*/, {
                                address: this.address,
                                privateKey: AESprivateKey,
                                publicKey: this.publicKey
                            }];
                }
            });
        });
    };
    return getAddress;
}());
export default getAddress;



//////////////////
// WEBPACK FOOTER
// ./src/ts/getAddress.ts
// module id = 258
// module chunks = 1